import { PremiumStatus } from '@wix/ambassador-premium-v1-asset/types'
import {
  FormsFieldPreset,
  FormPlugin,
  UpgradeAlertType,
  BillingPanelReferrer,
} from '@wix/forms-common'

type Limit = { limit: number; threshold?: number }
export type PremiumRestriction = {
  forms: Limit
  emails: Limit
  fields: Limit
  submissions: Limit
  rules: Limit
  steps: Limit
  allowedFields: {
    uploadButton?: boolean
    generalUploadButton?: boolean
    generalSignature?: boolean
  }
  allowedRedirections: { downloadFile?: boolean }
  allowedPlugins: { [FormPlugin.PAYMENT_FORM]?: boolean }
  isTopPremium?: boolean
}

export type Feature = {
  id: string
  uniqueName: string
  quotaFeature?: {
    limit: number
  }
  enabled: boolean
}

export type GetRestrictions = {
  restrictions: PremiumRestriction
  currentPlan: string
}

export const DEFAULT_RESTRICTIONS: PremiumRestriction = {
  forms: { limit: 5, threshold: 3 },
  fields: { limit: 10, threshold: 7 },
  rules: { limit: 3, threshold: 2 },
  submissions: { limit: 100, threshold: 70 },
  steps: { limit: 3, threshold: 2 },
  emails: { limit: 2, threshold: 2 },
  allowedRedirections: {},
  allowedFields: {},
  allowedPlugins: {},
}

type GetPackagePickerUrl = {
  msid: string
  appDefId: string
  origin: string
  vertical: string
}

export const getAscendPackagePickerUrl = ({
  msid,
  appDefId,
  origin,
  vertical,
}: GetPackagePickerUrl): string =>
  `https://www.wix.com/apps/upgrade?metaSiteId=${msid}&appDefId=${appDefId}&pp_origin=${origin}_${vertical}`

export const getPremiumPackagePickerUrl = ({
  msid,
  appDefId,
  origin,
  vertical,
}: GetPackagePickerUrl): string =>
  `https://www.wix.com/store/plans?appDefId=${appDefId}&referralAdditionalInfo=${origin}_${vertical}&siteGuid=${msid}`

export const referrerByAlertType = {
  [UpgradeAlertType.FORMS_LIMIT]: BillingPanelReferrer.NUMBER_OF_FORMS_ALERT,
  [UpgradeAlertType.FORMS_PAGE_LIMIT]: BillingPanelReferrer.NUMBER_OF_FORMS_ALERT,
  [UpgradeAlertType.FIELDS_LIMIT]: BillingPanelReferrer.NUMBER_OF_FIELDS_ALERT,
  [UpgradeAlertType.FIELDS_DUPLICATE_LIMIT]: BillingPanelReferrer.DUPLICATE_FIELD_ALERT,
  [UpgradeAlertType.STEPS_LIMIT]: BillingPanelReferrer.NUMBER_OF_STEPS_ALERT,
  [UpgradeAlertType.STEPS_DUPLICATE_LIMIT]: BillingPanelReferrer.NUMBER_OF_STEPS_ALERT,
  [UpgradeAlertType.UPLOAD_BUTTON]: BillingPanelReferrer.UPLOAD_FIELD_ALERT,
  [UpgradeAlertType.DOWNLOAD_REDIRECT]: BillingPanelReferrer.DOWNLOAD_REDIRECT_ALERT,
  [FormsFieldPreset.GENERAL_UPLOAD_BUTTON]: BillingPanelReferrer.UPLOAD_FIELD_ALERT,
  [UpgradeAlertType.EMAILS_LIMIT]: BillingPanelReferrer.NUMBER_OF_EMAILS_ALERT,
}

export const PREMIUM_PLAN_LIMITS = {
  [PremiumStatus.PREMIUM]: { formLimit: 150 },
  [PremiumStatus.FREE]: { formLimit: 4 },
  [PremiumStatus.UNKNOWN_PREMIUM_STATUS]: { formLimit: 4 },
  [PremiumStatus.PENDING]: { formLimit: 4 },
}
